import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import AppState, { SCREENS } from "../../AppState";

import LoadingScreen from "../LoadingScreen/LoadingScreen";
import QuizScreen from "../quiz/QuizScreen";
import "./App.css";

import ScaleManager from "../../ScaleManager";
import { toJS } from "mobx";


const App = () => {

  let s = ScaleManager.style

  return (
    <div className="App" >
      {AppState.screen === SCREENS.LOADING && <LoadingScreen/>}
      {AppState.screen === SCREENS.QUIZ && <QuizScreen />}
    </div>
  )
}

export default observer(App);
